import { CircularProgress, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core'
import Container from '../../components/layout/Container'
import React, { useEffect, useState, useRef } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import SearchIcon from '@material-ui/icons/Search';
import ControleAcessoService from "../../services/ControleAcessoService"
import { useSnackbar } from "notistack"
import PrivateRoute from '../../auth/private-route'
import { useAuth } from 'react-oidc-context'
import PesquisaOrgaoJuriscionado from '../../components/data_display/Consultas/PesquisaOrgaoJuriscionado'
import TipoOpcaoConsultaPerfil from '../../enums/tipoOpcaoConsultaPerfil'
import { v4 as uuid } from 'uuid'
import { UsuarioConsultaBox } from './styles'
import Paginacao from '../../components/data_display/Paginacao'
import { isNullReturnHyphen, DateFormat } from "../../functions"
import LogoTce from '../../assets/img/logo-tcego.svg'
import { useReactToPrint } from 'react-to-print';
import UsuarioPerfil from './UsuarioPerfil'
import ManutencaoPerfil from './ManutencaoPerfil'
import TipoOperacao from './../../../src/enums/tipoOperacao'
import webconfig from '../../webconfig.json'

export default function GerenciaPerfis(props) {
    const auth = useAuth()

    const [pagina, setPagina] = useState(1)
    const [qtdePagina, setQtdePagina] = useState(5)
    const [totalPagina, setTotalPagina] = useState(1)

    const [loading, setLoading] = useState(false)
    const [loadingCsv, setLoadingCsv] = useState(false)
    const [loadingPdf, setLoadingPdf] = useState(false)
    const [loadingProcesso, setLoadingProcesso] = useState(false)

    const { enqueueSnackbar } = useSnackbar()

    const [listaOrgaosJurisdicionados, setListaOrgaosJurisdicionados] = useState([])
    const [listaPerfis, setListaPerfis] = useState([])

    const [idOrgaoJurisdicionado, setIdOrgaoJurisdicionado] = useState(0)
    const [idOrgaoJurisdicionadoError, setIdOrgaoJurisdicionadoError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [objetoOrgaoJurisdicionadoSelecionado, setObjetoOrgaoJurisdicionadoSelecionado] = useState({})
    const [objetoOrgaoJurisdicionadoSelecionadoError, setObjetoOrgaoJurisdicionadoSelecionadoError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [opcaoConsulta, setOpcaoConsulta] = useState(-1)
    const [opcaoConsultaError, setOpcaoConsultaError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [cpfPesquisa, setCpfPesquisa] = useState('')
    const [cpfPesquisaError, setCpfPesquisaError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [perfilPesquisa, setPerfilPesquisa] = useState([])
    const [perfilPesquisaError, setPerfilPesquisaError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [nomeUsuarioPesquisa, setNomeUsuarioPesquisa] = useState('')
    const [nomeUsuarioPesquisaError, setNomeUsuarioPesquisaError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [termoPesquisa, setTermoPesquisa] = useState('')
    const [usuarios, setUsuarios] = useState([])
    const [usuariosPrint, setUsuariosPrint] = useState([])
    const [realizouPesquisa, setRealizouPesquisa] = useState(false)
    const [atualizarConsulta, setAtualizarConsulta] = useState(null)
    const [foiRevogacao, setFoiRevogacao] = useState(false)

    const componentRef = useRef();

    const [modalUsuario, setModalUsuario] = useState({
        open: false,
        obj: {}
    })

    const CarregaOrgaosJurisdicionados = () => {
        setLoading(true)
        ControleAcessoService.ConsultaOrgaosUsuario()
            .then(response => {
                setLoading(false)
                if (response.status === 200) {
                    let _listaOrgaosJurisdicionados = response.data
                    setListaOrgaosJurisdicionados(_listaOrgaosJurisdicionados)
                    setObjetoOrgaoJurisdicionadoSelecionado(_listaOrgaosJurisdicionados[0])
                    setIdOrgaoJurisdicionado(_listaOrgaosJurisdicionados[0].id)
                }
                else {
                    enqueueSnackbar('Não foi possível consultar os órgãos jurisdicionados. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        const validacao = JSON.parse(error.response.data.detail);
                        let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
                        for (let i = 0; i < validacao.Validacoes.length; i++) {

                            var itemValidado = validacao.Validacoes[i];
                            for (var propriedadeValidada in itemValidado) {
                                mensagem += itemValidado[propriedadeValidada];
                            }

                            if ((i + 1) < validacao.Validacoes.length) {
                                mensagem += "; ";
                            }
                        }

                        enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const CarregaPerfis = () => {
        setLoading(true)

        let idOrgaoJurisdicionadoSelecionado = 0

        if (objetoOrgaoJurisdicionadoSelecionado !== undefined &&
            objetoOrgaoJurisdicionadoSelecionado !== null &&
            objetoOrgaoJurisdicionadoSelecionado.id !== undefined &&
            objetoOrgaoJurisdicionadoSelecionado.id !== null) {
            idOrgaoJurisdicionadoSelecionado = objetoOrgaoJurisdicionadoSelecionado.id
        }

        ControleAcessoService.ConsultaPerfisGerenciarPerfis(idOrgaoJurisdicionadoSelecionado)
            .then(response => {
                setLoading(false)
                if (response.status === 200) {
                    setListaPerfis(response.data);
                }
                else {
                    enqueueSnackbar('Não foi possível consultar os perfis. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        const validacao = JSON.parse(error.response.data.detail);
                        let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
                        for (let i = 0; i < validacao.Validacoes.length; i++) {

                            var itemValidado = validacao.Validacoes[i];
                            for (var propriedadeValidada in itemValidado) {
                                mensagem += itemValidado[propriedadeValidada];
                            }

                            if ((i + 1) < validacao.Validacoes.length) {
                                mensagem += "; ";
                            }
                        }

                        enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const ConsultaUsuario = () => {
        setLoading(true)
        let _termoPesquisa = ''
        if (opcaoConsulta === TipoOpcaoConsultaPerfil.CPF) {
            _termoPesquisa = cpfPesquisa
            if (_termoPesquisa === '' ||
                _termoPesquisa === "" ||
                _termoPesquisa === undefined) {
                setLoading(false)
                enqueueSnackbar(`CPF deve ser informado!`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                return;
            }
        }
        else if (opcaoConsulta === TipoOpcaoConsultaPerfil.PERFIL) {
            _termoPesquisa = '' + perfilPesquisa
            if (_termoPesquisa === '' ||
                _termoPesquisa === "" ||
                _termoPesquisa === undefined) {
                setLoading(false)
                enqueueSnackbar(`Selecione um perfil de acesso!`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                return;
            }
        }
        else if (opcaoConsulta === TipoOpcaoConsultaPerfil.NOME_USUARIO) {
            _termoPesquisa = nomeUsuarioPesquisa
            if (_termoPesquisa === '' ||
                _termoPesquisa === "" ||
                _termoPesquisa === undefined) {
                setLoading(false)
                enqueueSnackbar(`Nome do usuário de rede deve ser informado!`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                return;
            }
        }

        setTermoPesquisa(_termoPesquisa)
        ControleAcessoService.ConsultaUsuario(_termoPesquisa, opcaoConsulta, pagina, qtdePagina, objetoOrgaoJurisdicionadoSelecionado.id)
            .then(response => {
                setLoading(false)
                setRealizouPesquisa(true)

                if (response.data.usuarioSemRegistro) {
                    if (foiRevogacao) {
                        setUsuarios([])
                    }
                    else {
                        setModalUsuario({
                            open: true,
                            obj: response.data.usuarios[0]
                        })
                    }
                }
                else {
                    setUsuarios(response.data.usuarios)
                    setModalUsuario({
                        open: false,
                        obj: response.data.usuarios[0]
                    })
                }

                setTotalPagina(response.data.totalPaginas)
            })
            .catch(error => {
                setLoading(false)
                setUsuarios([])
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        const validacao = JSON.parse(error.response.data.detail);
                        let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
                        for (let i = 0; i < validacao.Validacoes.length; i++) {

                            var itemValidado = validacao.Validacoes[i];
                            for (var propriedadeValidada in itemValidado) {
                                mensagem += itemValidado[propriedadeValidada];
                            }

                            if ((i + 1) < validacao.Validacoes.length) {
                                mensagem += "; ";
                            }
                        }

                        enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const exportaCsv = () => {
        setLoadingCsv(true)
        ControleAcessoService.ExportaCsv(termoPesquisa, opcaoConsulta, objetoOrgaoJurisdicionadoSelecionado.id)
            .then(response => {
                if (response.status === 200) {
                    let extensionFile = response.data.tipoArquivo
                    let a = document.createElement("a")
                    a.href = `data:${extensionFile};base64,${response.data.conteudo}`
                    a.download = response.data.nomeArquivo
                    a.click()

                    enqueueSnackbar('Download realizado com sucesso', { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoadingCsv(false)
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do arquivo CSV. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoadingCsv(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        const validacao = JSON.parse(error.response.data.detail);
                        let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
                        for (let i = 0; i < validacao.Validacoes.length; i++) {

                            var itemValidado = validacao.Validacoes[i];
                            for (var propriedadeValidada in itemValidado) {
                                mensagem += itemValidado[propriedadeValidada];
                            }

                            if ((i + 1) < validacao.Validacoes.length) {
                                mensagem += "; ";
                            }
                        }

                        enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const exportPdf = () => {
        ControleAcessoService.ConsultaUsuario(termoPesquisa, opcaoConsulta, 1, 100000, objetoOrgaoJurisdicionadoSelecionado.id)
            .then(response => {
                setUsuariosPrint(response.data.usuarios)
                handlePrint()
            })
            .catch(error => {
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        const validacao = JSON.parse(error.response.data.detail);
                        let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
                        for (let i = 0; i < validacao.Validacoes.length; i++) {

                            var itemValidado = validacao.Validacoes[i];
                            for (var propriedadeValidada in itemValidado) {
                                mensagem += itemValidado[propriedadeValidada];
                            }

                            if ((i + 1) < validacao.Validacoes.length) {
                                mensagem += "; ";
                            }
                        }

                        enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const LimpaConsulta = () => {
        setOpcaoConsulta(-1)
        setCpfPesquisa("")
        setPerfilPesquisa("")
        setNomeUsuarioPesquisa("")
        setTermoPesquisa("")
        setUsuarios([])
        setPagina(1)
        setRealizouPesquisa(false)
    }

    const AlteraOrgaoJurisdicionado = (e) => {
        let _objetoOrgaoJurisdicionadoSelecionado = {}
        if (e.target.value !== "") {
            setIdOrgaoJurisdicionado(e.target.value)
            for (let i = 0; i < listaOrgaosJurisdicionados.length; i++) {
                if (listaOrgaosJurisdicionados[i].id === e.target.value) {
                    _objetoOrgaoJurisdicionadoSelecionado = listaOrgaosJurisdicionados[i]
                }
            }
        }

        setObjetoOrgaoJurisdicionadoSelecionado(_objetoOrgaoJurisdicionadoSelecionado)
    }

    const AlteraOpcaoConsulta = (e) => {
        if (e.target.value !== "") {
            LimpaConsulta()
            setOpcaoConsulta(e.target.value)
        }
    }

    const ObtenhaOrgaosJurisdicionados = () => {
        var _orgaosJurisdicionados = [];

        for (let i = 0; i < listaOrgaosJurisdicionados.length; i++) {
            _orgaosJurisdicionados.push({
                value: listaOrgaosJurisdicionados[i].id,
                nome: listaOrgaosJurisdicionados[i].nome
            })
        }
        return _orgaosJurisdicionados
    }

    const ObtenhaOpcoesConsulta = () => {
        var _opcoesConsulta = [];

        if (auth !== undefined &&
            auth.user !== undefined &&
            ((auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') !== undefined ||
                auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GAC') !== undefined) ||
                (auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') !== undefined &&
                    objetoOrgaoJurisdicionadoSelecionado !== undefined &&
                    objetoOrgaoJurisdicionadoSelecionado.id !== 119))) {
            _opcoesConsulta.push({
                value: TipoOpcaoConsultaPerfil.CPF,
                nome: 'CPF'
            })
        }

        _opcoesConsulta.push({
            value: TipoOpcaoConsultaPerfil.PERFIL,
            nome: 'Perfil'
        })

        if (auth !== undefined &&
            auth.user !== undefined &&
            auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') !== undefined &&
            objetoOrgaoJurisdicionadoSelecionado !== undefined &&
            objetoOrgaoJurisdicionadoSelecionado.id === 119) {
            _opcoesConsulta.push({
                value: TipoOpcaoConsultaPerfil.NOME_USUARIO,
                nome: 'Nome do Usuário'
            })
        }

        return _opcoesConsulta
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Visitor Pass'
    });

    useEffect(() => {
        if (listaOrgaosJurisdicionados === null ||
            listaOrgaosJurisdicionados === undefined ||
            listaOrgaosJurisdicionados.length === 0) {
            CarregaOrgaosJurisdicionados()
        }
    }, [])

    useEffect(() => {
        LimpaConsulta()
        CarregaPerfis()
    }, [objetoOrgaoJurisdicionadoSelecionado])

    useEffect(() => {
        if (opcaoConsulta === TipoOpcaoConsultaPerfil.PERFIL) {
            CarregaPerfis()
        }
    }, [opcaoConsulta])

    useEffect(() => {
        if (opcaoConsulta >= 0) {
            if (atualizarConsulta !== null && foiRevogacao) {
                setFoiRevogacao(false)
                if (pagina > 1) {
                    setPagina(1)
                }
                else {
                    ConsultaUsuario()
                }
                return
            }

            ConsultaUsuario()
        }
    }, [pagina, qtdePagina, atualizarConsulta])

    class UsuarioPrint extends React.Component {
        render() {
            return (
                <UsuarioConsultaBox.PrintPage className="" >
                    <div style={{ paddingTop: "30px", textAlign: "center" }}>
                        <img src={LogoTce} alt="" />
                    </div>

                    <div style={{ fontSize: "24px", textAlign: "center" }}>
                        <span>Tribunal de Contas do Estado de Goiás</span>
                    </div>

                    <div style={{ fontSize: "16px", padding: "10px", textAlign: "center" }}>
                        <span>Gerenciar Perfis</span>
                    </div>

                    <div style={{ fontSize: "12px", width: "99%" }}>
                        <div style={{ display: "inline" }}>
                            <span>Usuário:</span>
                            <span style={{ paddingLeft: "5px" }}> {auth.user?.profile.name} </span>
                        </div>
                        <div style={{ display: "inline", float: "right" }}>
                            <span> Data:</span>
                            <span style={{ paddingLeft: "5px" }}>{isNullReturnHyphen(DateFormat(new Date()))} </span>
                        </div>
                    </div>

                    <br></br>

                    <div style={{ display: "table", fontSize: "12px", width: "99%", border: "solid", backgroundColor: "#e3e0e0", borderColor: "#000000" }}>
                        <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "20%" }}>
                            <span>Nome</span>
                        </div>
                        <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "20%" }}>
                            <span>Perfis</span>
                        </div>
                        <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "30%" }}>
                            <span>Órgãos</span>
                        </div>
                        <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "10%" }}>
                            <span>CPF</span>
                        </div>
                        <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "20%" }}>
                            <span>E-mail</span>
                        </div>
                    </div>

                    <div style={{ display: "table", fontSize: "10px", width: "99%", border: "solid", backgroundColor: "#ffffff", borderColor: "#000000" }}>
                        {usuariosPrint && usuariosPrint.length > 0 && usuariosPrint.map((usuario) => (
                            <div style={{ width: "100%" }}>
                                <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "20%" }}>
                                    <span>{isNullReturnHyphen(usuario.nome)}</span>
                                </div>
                                <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "20%" }}>
                                    <span>{isNullReturnHyphen(usuario.listaPerfis.map((x) => x.nome).join(', '))}</span>
                                </div>
                                <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "30%" }}>
                                    <span>{isNullReturnHyphen(usuario.listaOrgaosJurisdicionados.map((x) => x.nomeOrgaoJurisdicionado).join(', '))}</span>
                                </div>
                                <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "10%" }}>
                                    <span>{isNullReturnHyphen(usuario.cpf)}</span>
                                </div>
                                <div style={{ display: "table-cell", textAlign: "left", padding: "5px", width: "20%" }}>
                                    <span>{isNullReturnHyphen(usuario.email)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </UsuarioConsultaBox.PrintPage >
            )
        }
    }

    return (
        <PrivateRoute rolesAllowed={props.roles}>
            <Container title="Gerenciar Perfis">
                <div id="ContainerPage">

                    <ManutencaoPerfil
                        tipoOperacao={TipoOperacao.CADASTRO}
                        modalUsuario={modalUsuario}
                        setModalUsuario={setModalUsuario}
                        orgaoUsuarioLogado={objetoOrgaoJurisdicionadoSelecionado}
                        setAtualizarConsulta={setAtualizarConsulta}
                    />

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                            {auth &&
                                auth.user &&
                                auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') !== undefined && (
                                    <PesquisaOrgaoJuriscionado
                                        disabled={loading}
                                        value={objetoOrgaoJurisdicionadoSelecionado}
                                        setValue={setObjetoOrgaoJurisdicionadoSelecionado}
                                        error={objetoOrgaoJurisdicionadoSelecionadoError}
                                        titulo="Órgão"
                                        pesquisaParaDeferirAcessoGestor={false}
                                    />
                                )}

                            {auth &&
                                auth.user &&
                                (auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') !== undefined ||
                                    auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GAC') !== undefined) && (
                                    <FormControl variant="outlined">
                                        <InputLabel id="select-outlined-label-orgao" shrink>Órgão</InputLabel>
                                        <Select
                                            labelId="select-outlined-label-orgao"
                                            id="select-outlined-orgao"
                                            value={idOrgaoJurisdicionado}
                                            onChange={AlteraOrgaoJurisdicionado}
                                            label="Órgão"
                                            disabled={loading}
                                            error={idOrgaoJurisdicionadoError.errorState}
                                            placeholder=" "
                                        >
                                            {
                                                ObtenhaOrgaosJurisdicionados().map((orgao, index) => (
                                                    <MenuItem key={uuid()} value={orgao.value}>{orgao.nome}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                        {idOrgaoJurisdicionadoError.errorState && <FormHelperText className="error-form-helper-text">{idOrgaoJurisdicionadoError.errorHelperText}</FormHelperText>}
                                    </FormControl>
                                )}
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            {objetoOrgaoJurisdicionadoSelecionado && (
                                <FormControl variant="outlined">
                                    <InputLabel id="select-outlined-label-opcao-consulta" shrink>Opção de Consulta</InputLabel>
                                    <Select
                                        labelId="select-outlined-label-opcao-consulta"
                                        id="select-outlined-opcao-consulta"
                                        value={opcaoConsulta}
                                        onChange={AlteraOpcaoConsulta}
                                        label="Opção de Consulta"
                                        disabled={loading}
                                        error={opcaoConsultaError.errorState}
                                        placeholder=" "
                                    >
                                        <MenuItem value={''}>
                                            <em>Selecione uma opção</em>
                                        </MenuItem>
                                        {
                                            ObtenhaOpcoesConsulta().map((opcao, index) => (
                                                <MenuItem key={uuid()} value={opcao.value}>{opcao.nome}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                    {opcaoConsultaError.errorState && <FormHelperText className="error-form-helper-text">{opcaoConsultaError.errorHelperText}</FormHelperText>}
                                </FormControl>
                            )}

                        </Grid>

                        <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                            {objetoOrgaoJurisdicionadoSelecionado &&
                                opcaoConsulta === TipoOpcaoConsultaPerfil.CPF && (
                                    <FormControl variant="outlined">
                                        <TextField style={{ marginRight: '-25px' }}
                                            id="outlined-basic-ticket"
                                            variant="outlined"
                                            type="text"
                                            label="CPF"
                                            value={cpfPesquisa}
                                            onChange={event => {
                                                let numeroCpf = event.target.value
                                                numeroCpf = numeroCpf.replace(/\D/g, '')
                                                    .replace(/(\d{3})(\d)/, '$1.$2')
                                                    .replace(/(\d{3})(\d)/, '$1.$2')
                                                    .replace(/(\d{3})(\d)/, '$1-$2')
                                                    .replace(/(-\d{2})\d+?$/, '$1')
                                                setCpfPesquisa(numeroCpf)
                                            }}
                                            error={cpfPesquisaError.errorState}
                                            helperText={cpfPesquisaError.errorHelperText}
                                            inputProps={{
                                                maxLength: 14
                                            }}
                                        />
                                    </FormControl>
                                )}

                            {objetoOrgaoJurisdicionadoSelecionado &&
                                opcaoConsulta === TipoOpcaoConsultaPerfil.PERFIL && (
                                    <FormControl variant="outlined">
                                        <InputLabel id="select-outlined-label-prioridade" shrink>Perfil de Acesso</InputLabel>
                                        <Select style={{ marginRight: '-25px' }}
                                            labelId="select-outlined-label-prioridade"
                                            id="select-outlined-prioridade"
                                            value={perfilPesquisa}
                                            onChange={e => setPerfilPesquisa(e.target.value)}
                                            label="Perfil de Acesso"
                                            disabled={loading}
                                            error={perfilPesquisaError.errorState}
                                            placeholder=" "
                                        >
                                            <MenuItem value={''}>
                                                <em>Selecione uma opção</em>
                                            </MenuItem>
                                            <MenuItem value={0}>Todos</MenuItem>
                                            {
                                                listaPerfis.map((perfil, index) => (
                                                    <MenuItem key={uuid()} value={perfil.id}>{perfil.nome}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                        {perfilPesquisaError.errorState && <FormHelperText className="error-form-helper-text">{perfilPesquisaError.errorHelperText}</FormHelperText>}
                                    </FormControl>
                                )}

                            {objetoOrgaoJurisdicionadoSelecionado &&
                                opcaoConsulta === TipoOpcaoConsultaPerfil.NOME_USUARIO && (
                                    <FormControl variant="outlined">
                                        <TextField style={{ marginRight: '-25px' }}
                                            id="outlined-basic-ticket"
                                            variant="outlined"
                                            type="text"
                                            label="Nome do Usuário"
                                            value={nomeUsuarioPesquisa}
                                            onChange={event => setNomeUsuarioPesquisa(event.target.value)}
                                            error={nomeUsuarioPesquisaError.errorState}
                                            helperText={nomeUsuarioPesquisaError.errorHelperText}
                                            inputProps={{
                                                maxLength: 200
                                            }}
                                        />
                                    </FormControl>
                                )}

                        </Grid>

                        {objetoOrgaoJurisdicionadoSelecionado &&
                            opcaoConsulta > -1 && (
                                <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                                    <Tooltip title='Pesquisar Acesso' placement="top">
                                        <UsuarioConsultaBox.BotaoAcao
                                            className="bg-hover--ui-color-07 border--ui-color-07 color--ui-color-07 color-hover--ui-white"
                                            disabled={loadingProcesso}
                                            title='Pesquisar Acesso'
                                            onClick={ConsultaUsuario}
                                        >
                                            {
                                                loading
                                                    ?
                                                    <CircularProgress
                                                        size={22}
                                                        style={{
                                                            color: '#ffffff'
                                                        }} />
                                                    : <SearchIcon />
                                            }
                                        </UsuarioConsultaBox.BotaoAcao>
                                    </Tooltip>
                                </Grid>
                            )}

                    </Grid>
                </div>
                <br /><br /><br /><br />

                {usuarios && usuarios.length > 0 && (
                    <Paginacao
                        pagina={pagina}
                        qtdePagina={qtdePagina}
                        totalPagina={totalPagina}
                        setPagina={setPagina}
                        setQtdePagina={setQtdePagina}
                        exportaCsv={() => exportaCsv()}
                        exportPdf={() => exportPdf()}
                        loadingCsv={loadingCsv}
                        loadingPdf={loadingPdf}
                    />
                )}

                {usuarios && usuarios.length > 0 ? usuarios.map((usuario) => (
                    <UsuarioPerfil
                        usuario={usuario}
                        orgao={objetoOrgaoJurisdicionadoSelecionado}
                        setAtualizarConsulta={setAtualizarConsulta}
                        setFoiRevogacao={setFoiRevogacao}
                    />
                )) : <p>{realizouPesquisa ? "Nenhum usuário localizado para o órgão." : ""}</p>
                }

                {usuarios && usuarios.length > 0 && (
                    <Paginacao
                        pagina={pagina}
                        qtdePagina={qtdePagina}
                        totalPagina={totalPagina}
                        setPagina={setPagina}
                        setQtdePagina={setQtdePagina}
                        exportaCsv={() => exportaCsv()}
                        exportPdf={() => exportPdf()}
                        loadingCsv={loadingCsv}
                        loadingPdf={loadingPdf}
                    />
                )}

                <div style={{ display: 'none' }}>
                    <UsuarioPrint ref={componentRef} />
                </div>

                {/* <CardInformaca style={{ display: 'none' }}
                    itens={obtenhaItens()}
                /> */}
            </Container >
        </PrivateRoute>
    )
}